import { Component, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { ContextFieldConfig } from '../interfaces/builder-screen.models';

@Component({
  selector: 'app-context-fields-modal',
  templateUrl: './context-fields-modal.component.html',
  styleUrls: ['./context-fields-modal.component.scss'],
  standalone: false
})
export class ContextFieldsModalComponent implements OnInit {
  /** Todos os campos disponíveis no painel principal */
  availableFields: ContextFieldConfig[] = [];

  /** DataPaths dos campos que já estão selecionados */
  selectedDataPaths: Set<string> = new Set();

  /** Lista de campos com estado de seleção para o template */
  fieldItems: Array<{ field: ContextFieldConfig; checked: boolean }> = [];

  constructor(private modal: NzModalRef) {}

  ngOnInit(): void {
    this.fieldItems = this.availableFields.map(f => ({
      field: f,
      checked: this.selectedDataPaths.has(f.dataPath)
    }));
  }

  toggleField(item: { field: ContextFieldConfig; checked: boolean }): void {
    item.checked = !item.checked;
  }

  selectAll(): void {
    this.fieldItems.forEach(item => item.checked = true);
  }

  deselectAll(): void {
    this.fieldItems.forEach(item => item.checked = false);
  }

  get selectedCount(): number {
    return this.fieldItems.filter(i => i.checked).length;
  }

  handleOk(): void {
    const selected = this.fieldItems
      .filter(i => i.checked)
      .map(i => i.field);
    this.modal.close(selected);
  }

  trackByDataPath(index: number, item: { field: ContextFieldConfig; checked: boolean }): string {
    return item.field.dataPath;
  }

  handleCancel(): void {
    this.modal.close(undefined);
  }
}
